import React, { useState, useEffect } from "react";
import { Box, Grid, Button, TextField, Divider } from "@mui/material";
import { H3, H4, Small, H5, H6 } from "../../components/Typography";
import ReturnInformation from "../../components/ReturnInformation";
import FundInformation from "../../components/FundInformation";
import PortfolioDetails from "../../components/PortfolioDetails";
import OTPModel from "../../components/OTPModel";
import SIPdateModel from "../../components/SIPdateModel";
import aesEncrypt from "../../constants/aesEncrypt";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import moment from "moment";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DashboardNavbar from "../../components/DashboardNavbar";
import { AreaChart, Tooltip, Area, ResponsiveContainer } from "recharts";
import { load, remove } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import * as Models from "../../models";
import { toast } from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { CreateFundingRules, CreatePOT } from "../../redux/actions/GoalAction";
import {
  getFundCard,
  getFundHolding,
  getGraphNAVData,
  getFundisin,
  orderMutualFund,
  orderLumpsumMutualFund,
  otpGenerateForMutualFund,
  otpVerifyForMutualFund,
  createSIPMandate,
} from "../../redux/actions/PortfolioAction";
import { API_BASE_URL } from "../../Api/EndPoints";
import AmcInformation from "../../components/AmcInformation";
import FundHouseInformation from "../../components/FundHouseInformation";

export default function MFFundDetails() {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  let routeData = useLocation();
  const { data, goalData } = routeData.state;
  console.log("-mff-----data----", data);

  const [selected, setSelected] = useState(1);
  const [metalType, setMetalType] = useState(data?.isGoal ? "Sip" : "Onetime");
  const [fundType, setFundType] = useState("Returns");
  const [schemeCode, setSchemeCode] = useState(data?.scheme_code);
  const [chartVisible, setChartVisible] = useState(false);
  const [flexiData, setFlexiData] = useState<any>();
  const [fundHoldingData, setFundHoldingData] = useState();
  const [buttonValue, setButtonValue] = useState("");
  const [buttonData, setButtonData] = useState([]);
  const [graphData, setGraphData] = useState<{ name: string; nav: any }[]>([]);
  const [loading, setLoading] = useState(true);
  const [tabloader, setTabLoader] = useState(false);
  const [ISIN, setISIN] = useState("");
  //fund sip
  const [fundDetails, setFundDetails] = useState<string>("");
  const [investedAmount, setInvestedAmount] = useState<string>("");
  const [investedSipAmount, setInvestedSipAmount] = useState<string>("");
  const [minSipAmount, setMinSipAmount] = useState<string>("");
  const [maxSipAmount, setMaxSipAmount] = useState<string>("");

  //One Time
  const [buyInvestedAmount, setBuyInvestedAmount] = useState<string>("");
  const [buyMinAmount, setBuyMinAmount] = useState<string>("");
  const [buyMaxAmount, setBuyMaxAmount] = useState<string>("");

  // One Time Button
  const [firstTouchableOpacity, setFirstTouchableOpacity] = useState(true);
  const [secondTouchableOpacity, setSecondTouchableOpacity] = useState(false);
  const [thirdTouchableOpacity, setThirdTouchableOpacity] = useState(false);
  const [fourthTouchableOpacity, setFourthTouchableOpacity] = useState(false);
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [thirdValue, setThirdValue] = useState("");

  // Sip Button
  const [selectedDate, setSelectedDate] = useState("");
  const [sipDateList, setDateList] = useState();
  const [sipLastDate, setSipLastDate] = useState();

  const [paymentValue, setPaymentValue] = useState("upi");
  const [virtualAccID, setVirtualAccID] = useState("");
  useEffect(() => {
     checkToken();
  }, [schemeCode, metalType]);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      if (schemeCode) {
        getMutualFundCardData();
        getFundHoldingData();
      }
      getFundSipDetail();
      returnGraphData("3Y");
    }
  };
  //otp model
  const [openModal, setOpenModal] = useState(false);
  const [requestID, setRequestID] = React.useState("");
  useEffect(() => {
    if (openModal) {
      window.history.pushState(null, "", window.location.pathname);
      window.addEventListener("popstate", onBackButtonEvent);
      return () => {
        window.removeEventListener("popstate", onBackButtonEvent);
      };
    }
  }, []);
  function onBackButtonEvent(e: PopStateEvent) {
    e.preventDefault();
    window.history.pushState(null, "", window.location.pathname);
  }
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  //sip model
  const [sipdateModel, setSipDateModel] = useState(false);

  const handlesipOpenModal = () => {
    setSipDateModel(true);
  };
  const handlesipCloseModal = () => {
    setSipDateModel(false);
  };
  const handleChangePaymentrValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPaymentValue((event.target as HTMLInputElement).value);
  };

  const getImgUrl = (pic: string) => {
    pic = pic?.toString().slice(1);
    if (pic) {
      return API_BASE_URL + pic;
    }
    return "";
  };

  const returnGraphData = async (val: any) => {
    setChartVisible(false);
    // Get the current date
    const today = new Date();
    const todayFormatted = today.toISOString().slice(0, 10);

    // One month ago
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);
    const oneMonthAgoFormatted = oneMonthAgo.toISOString().slice(0, 10);

    // Three months ago
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const threeMonthsAgoFormatted = threeMonthsAgo.toISOString().slice(0, 10);

    // Six months ago
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - 6);
    const sixMonthsAgoFormatted = sixMonthsAgo.toISOString().slice(0, 10);

    // One year ago
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    const oneYearAgoFormatted = oneYearAgo.toISOString().slice(0, 10);

    // Three years ago
    const threeYearsAgo = new Date();
    threeYearsAgo.setFullYear(today.getFullYear() - 3);
    const threeYearsAgoFormatted = threeYearsAgo.toISOString().slice(0, 10);

    // five years ago
    const fiveYearsAgo = new Date();
    fiveYearsAgo.setFullYear(today.getFullYear() - 5);
    const fiveYearsAgoFormatted = fiveYearsAgo.toISOString().slice(0, 10);

    // Seven years ago
    const sevenYearsAgo = new Date();
    sevenYearsAgo.setFullYear(today.getFullYear() - 7);
    const sevenYearsAgoFormatted = sevenYearsAgo.toISOString().slice(0, 10);
    if (val === "1M") {
      const req = {
        schemecode: schemeCode,
        fromDate: oneMonthAgoFormatted,
        toDate: todayFormatted,
        frequency: "day",
      };
      getFundGraphData(req);
    } else if (val === "3M") {
      const req = {
        schemecode: schemeCode,
        fromDate: threeMonthsAgoFormatted,
        toDate: todayFormatted,
        frequency: "day",
      };
      getFundGraphData(req);
    } else if (val === "6M") {
      const req = {
        schemecode: schemeCode,
        fromDate: sixMonthsAgoFormatted,
        toDate: todayFormatted,
        frequency: "day",
      };
      getFundGraphData(req);
    } else if (val === "1Y") {
      const req = {
        schemecode: schemeCode,
        fromDate: oneYearAgoFormatted,
        toDate: todayFormatted,
        frequency: "day",
      };
      getFundGraphData(req);
    } else if (val === "3Y") {
      const req = {
        schemecode: schemeCode,
        fromDate: threeYearsAgoFormatted,
        toDate: todayFormatted,
        frequency: "week",
      };
      await getFundGraphData(req);
    } else if (val === "5Y") {
      const req = {
        schemecode: schemeCode,
        fromDate: fiveYearsAgoFormatted,
        toDate: todayFormatted,
        frequency: "week",
      };
      getFundGraphData(req);
    } else if (val === "7Y") {
      const req = {
        schemecode: schemeCode,
        fromDate: sevenYearsAgoFormatted,
        toDate: todayFormatted,
        frequency: "week",
      };
      getFundGraphData(req);
    }
  };

  // Graph Data
  const getFundGraphData = async (req: any) => {
    let token = load("token");
    dispatch(getGraphNAVData(req, `bearer ${token}`))
      .then(async (response: any) => {
        const navData = response.data.nav_history;
        const formattedData = Object.keys(navData).map((date) => ({
          name: date,
          nav: navData[date],
        }));
        setGraphData(formattedData);

        setChartVisible(true);
      })
      .catch((error: any) => {
        setChartVisible(true);
        toast.error(error);
      });
  };

  const dots = () => {
    return <Grid sx={sxStyleDotStyle} />;
  };
  const getFundSipDetail = async () => {
    // setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualFundsDetailRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: data.isin,
    };

    dispatch(getFundisin(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        setISIN(response?.holdings?.isin ?? "");
        setFundDetails(response?.holdings ?? "");
        //sip
        setMinSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.min_installment_amount
        );
        setMaxSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.max_installment_amount
        );
        setInvestedSipAmount(
          data?.isGoal
            ? goalData.sipAmount
            : response?.holdings?.sip_frequency_specific_data?.monthly
                ?.min_installment_amount
        );

        //Buy fund
        setInvestedAmount(response?.holdings.min_initial_investment ?? "");
        setBuyInvestedAmount(response?.holdings.min_initial_investment ?? "");
        setBuyMinAmount(response?.holdings?.min_initial_investment ?? "");
        setBuyMaxAmount(response?.holdings?.max_initial_investment ?? "");
        if (response?.holdings?.sip_frequency_data) {
          const dateListString =
            response?.holdings?.sip_frequency_data["MONTHLY"];
          const dateList = dateListString.split(",");
          setDateList(dateList);
          setSipLastDate(
            dateList?.length > 0 ? dateList[dateList?.length - 1] : ""
          );
        }
        setFirstValue("2");
        setSecondValue("5");
        setThirdValue("10");
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getMutualFundCardData = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    // setLoading(true);
    let token = load("token");
    const req: Models.MutualFundsCardRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      scheme_code: schemeCode,
    };

    dispatch(getFundCard(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.statusCode === 400) {
          return;
        }
        setFlexiData(response?.fundCard);
        buttonText(response?.fundCard?.mf_trailing);
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getFundHoldingData = async () => {
    // setLoading(true);
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.MutualFundsHoldingRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      schemecode: schemeCode,
    };

    dispatch(getFundHolding(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        setFundHoldingData(response.holdings);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  const buttonText = (data: any) => {
    let returntabledate: any;
    let returndataData: any;

    const returnsarr = data;
    if (returnsarr.length == 1) {
      returntabledate = ["1 Month"];
      returndataData = ["1M"];
      setButtonValue("1M");
      setButtonData(returndataData);
    } else if (returnsarr.length == 2) {
      returntabledate = ["1 Month", "3 Months"];
      returndataData = ["1M", "3M"];
      setButtonValue("3M");
      setButtonData(returndataData);
    } else if (returnsarr.length == 3) {
      returntabledate = ["1 Month", "3 Months", "6 Months"];
      returndataData = ["1M", "3M", "6M"];
      setButtonValue("6M");
      setButtonData(returndataData);
    } else if (returnsarr.length == 4) {
      returntabledate = ["1 Month", "3 Months", "6 Months", "1 Year"];
      returndataData = ["1M", "3M", "6M", "1Y"];
      setButtonData(returndataData);
      setButtonValue("1Y");
    } else if (returnsarr.length == 5) {
      returntabledate = [
        "1 Month",
        "3 Months",
        "6 Months",
        "1 Year",
        "3 Years",
      ];
      returndataData = ["1M", "3M", "6M", "1Y", "3Y"];
      setButtonData(returndataData);
      setButtonValue("3Y");
    } else if (returnsarr.length == 6) {
      returntabledate = [
        "1 Month",
        "3 Months",
        "6 Months",
        "1 Year",
        "3 Years",
        "5 Years",
      ];
      returndataData = ["1M", "3M", "6M", "1Y", "3Y", "5Y"];
      setButtonData(returndataData);
      setButtonValue("3Y");
    } else if (returnsarr.length == 7) {
      returntabledate = [
        "1 Month",
        "3 Months",
        "6 Months",
        "1 Year",
        "3 Years",
        "5 Years",
        "7 Years",
      ];
      returndataData = ["1M", "3M", "6M", "1Y", "3Y", "5Y", "7Y"];
      setButtonData(returndataData);
      setButtonValue("3Y");
    }
  };
  const finalReturnData = (item: any) => {
    const fundReturns = item?.mf_trailing?.map((obj: any) => {
      return {
        key: Object.keys(obj)[0],
        val: Object.values(obj)[0],
      };
    });

    if (fundReturns?.length == 0) {
      return { key: "", value: "" };
    }

    const threeYearReturn = fundReturns?.filter(
      (em: any) => em?.key == buttonValue
    );
    if (threeYearReturn?.length > 0) {
      return threeYearReturn[0];
    }

    return fundReturns[fundReturns?.length - 1];
  };

  const createOrder = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualLumpSumFundCreateOrderRequest = {
      userId:  userDetails.id,
      mobileNo: userDetails.mobile,
      userName: `${userDetails?.firstname} ${userDetails?.lastname}`,
      schemeId: data?.isin,
      schemeName: data?.scheme_name,
      folioNumber: "",
      investmentType:  "PURCHASE",
      amount: Number(investedAmount),
      callBackUrl: process.env.REACT_APP_MF_BUY_CALL_BACK_URL || "",
    }
    // const req: Models.MutualFundCreateOrderRequest = {
    //   id: userDetails.id,
    //   mobile: userDetails.mobile,
    //   partner: userDetails?.refcode,
    //   source: "DIRECT",
    //   callbackUrl: process.env.REACT_APP_MF_BUY_CALL_BACK_URL || "",
    //   purchase_type: "PURCHASE",
    //   source_id: 0,
    //   payment_mode: paymentValue,
    //   orders: [
    //     {
    //       amc_code: data?.amc_code ?? "",
    //       isin: data?.isin,
    //       amount: investedAmount,
    //       folio_number: null,
    //       user_ip: "192.168.2.92",
    //       server_ip: "192.168.2.95",
    //     },
    //   ],
    // };

    dispatch(orderLumpsumMutualFund(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          toast?.error(response?.message);
          return;
        }
        // if (response.statusCode == 500) {
        //   toast?.error(response?.message);
        //   return;
        // }
        if (userDetails?.mode === "Assisted") {
          window.open(response?.data?.token_url, "_blank");
          navigate("/transaction", {
            state: {
              type: "mutualFund",
            },
          });
        } else {
          window.open(response?.data?.token_url, "_self");
        }
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const dateOrdinal = (d: any) => {
    return (
      d +
      (31 == d || 21 == d || 1 == d
        ? "st"
        : 22 == d || 2 == d
        ? "nd"
        : 23 == d || 3 == d
        ? "rd"
        : "th")
    );
  };

  //verify OTP OneTime
  const handleSave = async (value: any) => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");

    const req = {
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      request_id: requestID,
      otp: aesEncrypt(value),
    };

    dispatch(otpVerifyForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "OTP Authenticated Successfuly") {
          handleCloseModal();
          if (metalType === "Onetime") {
            await createOrder();
          } else {
            await createSIP();
          }
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const createSIP = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);

    const consent: Models.ConsentRequest = {
      email: userDetails.email ?? "",
      isd_code: "91",
      mobile: userDetails?.mobile ?? "",
    };
    const req = {
      userId: userDetails.id,
      bankAccId: userDetails.bank_acc_id,
      amount: investedSipAmount,
      scheme: ISIN,
      installmentDay: selectedDate,
      mfInvestmentAccount: userDetails.mfia_id,
      consent: consent,
      virtualAccountId: virtualAccID,
    };

    dispatch(createSIPMandate(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);

        if (response.statusCode === 400) {
          toast.error(
            response?.error?.message ??
              "Got error while getting a fund details, please try after sometimes!"
          );
          return;
        }
        if (response.statusCode === 500) {
          toast.error(
            "Got error while getting a fund details, please try after sometimes!"
          );
          return;
        }
        if (response.statusCode === 200) {
          if (userDetails?.mode === "Assisted") {
            window.open(response.data.token_url, "_blank");
            navigate("/transaction", {
              state: {
                type: "mutualFund",
              },
            });
          } else {
            window.open(response.data.token_url, "_self");
          }
        } else {
          toast.error(response?.error);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Got error while getting a fund details, please try after sometimes!"
        );
      });
  };

  //OTP
  const generateOTP = (req: any) => {
    setLoading(true);
    let token = load("token");

    dispatch(otpGenerateForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response?.type === "success") {
          toast.success(response.message);
          handleOpenModal();
          setRequestID(response.request_id);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  // MF Next Buy
  const onNextBuyClick = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    if (userDetails?.user_status != "ACTIVE") {
      toast.error("Please complete your KYC");
      return;
    }
    if (investedAmount === "") {
      toast.error("Please enter amount");
      return;
    }
    if (investedAmount < buyInvestedAmount) {
      toast.error(`Minimum investment amount is ₹${buyInvestedAmount}`);
      return;
    }
    if (investedAmount > buyMaxAmount) {
      toast.error(`Maximum investment amount is ₹${buyMaxAmount}`);
      return;
    }

    if (userDetails?.user_status === "KYCREJECTED") {
      toast.error("Redo KYC");
      return;
    }

    //MF BUY
    const req = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      purpose: "direct_purchase",
      fund_name: data?.scheme_name ?? "",
      amount: investedAmount,
    };
    await generateOTP(req);
  };

  // MF SIP
  const onNextSIPClick = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);

    if (data.sip_allowed === "N") {
      toast.error("SIP is not available for this fund");
      return;
    }
    if (userDetails?.user_status != "ACTIVE") {
      toast.error("Please complete your KYC");
      return;
    }
    if (!selectedDate) {
      toast.error(`Please select SIP date`);
      return;
    }
    if (investedSipAmount < minSipAmount) {
      toast.error(`Minimum SIP amount is ₹${minSipAmount}`);
      return;
    }
    if (investedSipAmount > maxSipAmount) {
      toast.error(`SIP amount is cannot be greater than ₹${maxSipAmount}`);
      return;
    }
    if (data.isGoal) {
      await createGoal(goalData);
      return;
    }

    //SIP
    const req = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      purpose: "purchase_mutual_fund",
      fund_name: data?.scheme_name ?? "",
      amount: investedSipAmount,
    };
    await generateOTP(req);
  };

  const createGoal = async (item: any) => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.CreatePotRequest = {
      userId: userDetails.id,
      accountType: "fixed",
      accountName: `${item.goalName} Goal`,
      accountBalance: Number(item.goalAmount),
      accountStatus: "ACTIVE",
      productId: data?.isin,
      productName: data?.scheme_name,
    };

    dispatch(CreatePOT(req, `${token}`))
      .then(async (response: any) => {
        if (
          response.status === 401 ||
          response.statusCode === 400 ||
          response.statusCode === 401
        ) {
          setLoading(false);
          toast.error(response.message);
          return;
        }

        await createFundingRulesGoal(
          response?.data?.virtualAccountId,
          userDetails
        );
        setVirtualAccID(response?.data?.virtualAccountId);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const createFundingRulesGoal = async (
    virtualAccountId: string,
    userDetails: any
  ) => {
    setLoading(true);
    const format = "YYYY-MM-DD";
    var d = new Date();
    d.setDate(Number(selectedDate));
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var endDate = moment(
      new Date(d.getFullYear() + goalData.year, month, Number(selectedDate))
    ).format(format);
    var nextDate = moment(new Date(d.setMonth(d.getMonth() + 1))).format(
      format
    );

    let token = load("token");
    const req: Models.CreateFundingRulesRequest = {
      userId: userDetails.id,
      fundingType: "FIX",
      autoFundingMethod: "emandate",
      fundingFrequency: "Monthly",
      roundingMethod: "",
      denomination: investedAmount,
      startDate: moment(new Date()).format(format),
      endDate: endDate.toString(),
      nextDate: nextDate.toString(),
      virtualAccountId: virtualAccountId,
      subscriptionFrequencyUnit: "ONDEMAND",
      name: `${userDetails.firstname} ${userDetails.lastname}`,
      mobileNo: userDetails.mobile,
    };

    dispatch(CreateFundingRules(req, `${token}`))
      .then(async (response: any) => {
        if (response.statusCodeValue === 400) {
          setLoading(false);
          toast.error(response.body.message);
          return;
        }
        if (response?.statusCode == 200) {
          // await getOTP();
          //GOAL
          const req = {
            id: userDetails.id,
            mobile: userDetails.mobile,
            partner: userDetails?.refcode,
            purpose: "purchase_mutual_fund",
            fund_name: data?.scheme_name ?? "",
            amount: investedSipAmount,
          };
          await generateOTP(req);
        }
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };
  //OneTme Edit
  const oneTimeChangeHandler: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;
    setInvestedAmount(value);
  };

  // SIP Edit
  const sipChangeHandler: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;
    setInvestedSipAmount(value);
  };
  const handleSaveSipDateModel = (value: any) => {
    setSelectedDate(value);
    handlesipCloseModal();
  };
  return (
    <>
      <DashboardNavbar />
      <Grid sx={sxStylebutton}>
        {loading ? (
          <Grid
            height="100vh"
            display="flex"
            flexDirection="column"
            sx={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <>
            <Grid container>
              <Box
                sx={{
                  display: { sm: "none", md: "none", xs: "flex" },
                  pb: 1,
                  pl: 1,
                  pr: 1,
                  mt: 3,
                  borderRadius: 1,
                }}
              >
                <Box
                  component="img"
                  src={
                    flexiData?.general_info?.logo
                      ? getImgUrl(flexiData?.general_info?.logo)
                      : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                  }
                  sx={sxStyleImage}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginLeft: 1.5,
                  }}
                >
                  <H4 fontSize={14} fontWeight={500} color="#000000" sx={text}>
                    {flexiData?.general_info?.scheme_name}
                  </H4>

                  <Grid
                    alignItems="center"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 0.5,
                    }}
                  >
                    <H6
                      color="#747474"
                      fontWeight={"400"}
                      sx={{ mr: 1, display: "flex" }}
                    >
                      {dots()}
                      {flexiData?.metadata?.risk_profile}
                    </H6>
                    <H6
                      color="#747474"
                      fontWeight={"400"}
                      sx={{ mr: 1, display: "flex" }}
                    >
                      {dots()}
                      {flexiData?.metadata?.asset_category}
                    </H6>
                    <H6
                      color="#747474"
                      fontWeight={"400"}
                      sx={{ mr: 1, display: "flex" }}
                    >
                      {dots()}
                      {flexiData?.metadata?.asset_sub_category == "Tax Savings"
                        ? "Tax Savings"
                        : flexiData?.metadata?.option_name}
                    </H6>
                  </Grid>
                </Box>
              </Box>
              {/* Graph View */}
              <Grid
                xs={12}
                md={6}
                sx={{
                  padding: {
                    md: 3,
                    xs: 0,
                    sm: 0,
                  },
                  pr: 2,
                  mt: 2,
                }}
              >
                <Grid
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 5,
                  }}
                >
                  <H3
                    fontWeight={400}
                    fontSize={14}
                    sx={{
                      pt: 2,
                      ml: 2,
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {finalReturnData(flexiData)?.key} Returns
                  </H3>
                  <H3
                    fontWeight={400}
                    fontSize={14}
                    color="#5C8C00"
                    sx={{
                      ml: 2,
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {finalReturnData(flexiData)?.val}%
                  </H3>
                  {/* width={610} height={450} */}
                  {chartVisible ? (
                    <Grid
                      sx={{
                        width: "100%",
                        height: {
                          xs: "250px",
                          sm: "500px",
                          md: "450px",
                        },
                      }}
                    >
                      <ResponsiveContainer
                        aspect={3.0 / 2.0}
                        width="100%"
                        height="100%"
                      >
                        <AreaChart data={graphData}>
                          <defs>
                            <linearGradient
                              id="gradient"
                              x1="0"
                              y1="0"
                              x2="0"
                              y2="1"
                            >
                              <stop
                                offset="5%"
                                stopColor="#A9CAFF"
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="95%"
                                stopColor="#8884d8"
                                stopOpacity={0}
                              />
                            </linearGradient>
                          </defs>

                          <Area
                            type="monotone"
                            dataKey="nav"
                            stroke="#8884d8"
                            fill="url(#gradient)"
                          />
                          <Tooltip
                            labelFormatter={() => ""} // Return null to hide the index label
                            formatter={(value, name, props) => [
                              `NAV: ${(Number(value) || 0).toFixed(2)} Date: ${
                                props.payload.name
                              }`,
                            ]}
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </Grid>
                  ) : (
                    <Box
                      height={450}
                      display="flex"
                      flexDirection="column"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}

                  <Grid spacing={2} sx={sxStyleGrid9}>
                    {buttonData.map((graph: any, index) => (
                      <Box
                        onClick={() => {
                          returnGraphData(graph);
                          setButtonValue(graph);
                        }}
                        sx={{
                          background:
                            buttonValue === graph
                              ? process.env.REACT_APP_PRIMARY_COLOR
                              : "#FEF7E3",
                          borderRadius: 2,
                          p: 1,
                          pt: 0.4,
                          cursor: "pointer",
                          mb: 3,
                        }}
                      >
                        <Small
                          fontWeight={"700"}
                          sx={{
                            color: buttonValue === graph ? "#fff" : "#000",
                          }}
                        >
                          {graph}
                        </Small>
                      </Box>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              {/* 2nd View */}
              <Grid
                xs={12}
                md={6}
                sx={{
                  padding: {
                    md: 3,
                    xs: 0,
                    sm: 0,
                  },
                  pr: 2,
                  mt: 1,
                }}
              >
                <Grid
                  sx={{
                    background: "#fff",
                    borderRadius: 5,
                    paddingX: {
                      md: 2,
                      xs: 1,
                    },
                    paddingY: {
                      md: 3,
                      xs: 1.5,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: { sm: "flex", md: "flex", xs: "none" },
                      pb: 1,
                      pl: 1,
                      pr: 1,
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        flexiData?.general_info?.logo
                          ? getImgUrl(flexiData?.general_info?.logo)
                          : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                      }
                      sx={sxStyleImage}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginLeft: 1.5,
                      }}
                    >
                      <H4
                        fontSize={14}
                        fontWeight={500}
                        color="#000000"
                        sx={text}
                      >
                        {flexiData?.general_info?.scheme_name}
                      </H4>

                      <Grid alignItems="center" sx={{ display: "flex" }}>
                        {dots()}
                        <H5 color="#747474" fontWeight={"400"} sx={{ mr: 1 }}>
                          {flexiData?.metadata?.risk_profile}
                        </H5>
                        {dots()}
                        <H5 color="#747474" fontWeight={"400"} sx={{ mr: 1 }}>
                          {flexiData?.metadata?.asset_category}
                        </H5>
                        {dots()}
                        <H5 color="#747474" fontWeight={"400"}>
                          {flexiData?.metadata?.asset_sub_category ==
                          "Tax Savings"
                            ? "Tax Savings"
                            : flexiData?.metadata?.option_name}
                        </H5>
                      </Grid>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      borderRadius: 4,
                      ml: { xs: 1, sm: 1, md: 2 },
                      mr: { xs: 1, sm: 1, md: 2 },
                      mb: { xs: 1, sm: 1, md: 1 },
                      mt: { xs: 1, sm: 1, md: 1 },
                      boxShadow: "0px 4px 10px rgba(239, 239, 239, 1)",
                    }}
                  >
                    {/* NAV/Rating */}
                    <Grid
                      sx={{
                        display: "flex",
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                      }}
                    >
                      <Grid
                        sx={{
                          width: "50%",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          borderTopColor: "#EFEFEF",
                          borderTopWidth: 0.2,
                          mt: 0.5,
                          mb: 0.5,
                        }}
                      >
                        <H4
                          color="#000"
                          fontSize={14}
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                          fontWeight={"600"}
                        >
                          {flexiData?.metadata?.nav}
                        </H4>
                        <H5
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                          fontSize={12}
                          color={"#868686"}
                          fontWeight={"400"}
                        >
                          NAV
                        </H5>
                      </Grid>
                      <Grid
                        sx={{
                          width: "50%",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",

                          borderLeftWidth: "1px", // set the left border width to 2 pixels
                          borderLeftStyle: "solid", // set the left border style to solid
                          borderLeftColor: "#EFEFEF", // set the left border color

                          pt: 0.5,
                          pb: 0.5,
                        }}
                      >
                        <Grid
                          justifyContent="center"
                          alignItems="center"
                          sx={{ display: "flex" }}
                        >
                          <H4
                            color="#000"
                            fontSize={14}
                            sx={{
                              width: "100%",
                              textAlign: "center",
                            }}
                            fontWeight={"600"}
                          >
                            {flexiData?.metadata?.vr_rating == "Not Rated" ||
                            flexiData?.metadata?.vr_rating?.length <= 0
                              ? 0
                              : flexiData?.metadata?.vr_rating?.length}
                          </H4>

                          <Box
                            component="img"
                            sx={{
                              justifyContent: "center",
                              alignItems: "center",
                              height: 12,
                              minwidth: {
                                md: 20,
                                xs: 70,
                                sm: 60,
                              },
                              ml: 0.5,
                            }}
                            src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/startIcon.svg"
                            alt="saas-dasboard-footer"
                          />
                        </Grid>
                        <H5
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                          fontSize={12}
                          color={"#868686"}
                          fontWeight={"400"}
                        >
                          Rating
                        </H5>
                      </Grid>
                    </Grid>
                    {/* Investment /Size */}
                    <Divider sx={{ color: "#EFEFEF" }} />
                    <Grid
                      sx={{
                        display: "flex",
                        borderColor: "#EFEFEF",
                        borderBottomLeftRadius: 15,
                        borderTopColor: "#EFEFEF",
                        borderTopWidth: 1,
                        borderBottomRightRadius: 15,
                      }}
                    >
                      <Grid
                        sx={{
                          width: "50%",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          borderTopColor: "#EFEFEF",
                          borderTopWidth: 1,
                          mt: 0.5,
                          mb: 0.5,
                        }}
                      >
                        <H4
                          color="#000"
                          fontSize={14}
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                          fontWeight={"600"}
                        >
                          {flexiData?.txn_info?.min_invest}
                        </H4>
                        <H5
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                          color={"#868686"}
                          fontWeight={"400"}
                          fontSize={12}
                        >
                          Min. Investment
                        </H5>
                      </Grid>
                      <Grid
                        sx={{
                          width: "50%",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",

                          borderLeftWidth: "1px", // set the left border width to 2 pixels
                          borderLeftStyle: "solid", // set the left border style to solid
                          borderLeftColor: "#EFEFEF", // set the left border color
                          pt: 0.5,
                          pb: 0.5,
                        }}
                      >
                        <H4
                          color="#000"
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                          fontSize={14}
                          fontWeight={"600"}
                        >
                          {flexiData?.metadata?.fund_size} Cr
                        </H4>
                        <H5
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                          fontSize={12}
                          color={"#868686"}
                          fontWeight={"400"}
                        >
                          Fund Size
                        </H5>
                      </Grid>
                    </Grid>
                  </Box>
                  {/* sip/onetime Tab*/}
                  {tabloader ? (
                    <Grid
                      display="flex"
                      flexDirection="column"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: 20,
                      }}
                    >
                      <CircularProgress />
                    </Grid>
                  ) : (
                    <Box sx={sxStyleBox1}>
                      {data?.isGoal ? null : (
                        <Button
                          onClick={() => {
                            setSelected(1);
                            setMetalType("Onetime");
                          }}
                          disableElevation
                          disableRipple
                          size="medium"
                          sx={{
                            fontSize: {
                              xs: "12px",
                              sm: "12px",
                              md: "14px",
                            },
                            boxShadow: "0px 4px 4px rgba(239, 239, 239, 1)",
                            textTransform: "none",
                            background:
                              metalType === "Onetime"
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FFF",
                            color: metalType === "Onetime" ? "#fff" : "#000",
                            width: "50%",
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0,
                            borderTopLeftRadius: 10,
                            borderBottomLeftRadius: 0,
                            pt: 1.5,
                            pb: 1.5,
                            "&:hover": {
                              background:
                                metalType === "Onetime"
                                  ? process.env.REACT_APP_PRIMARY_COLOR
                                  : "#FFF",
                            },
                          }}
                        >
                          One Time
                        </Button>
                      )}

                      <Button
                        disableElevation
                        disableRipple
                        onClick={() => {
                          setSelected(1);
                          setMetalType("Sip");
                        }}
                        size="medium"
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "12px",
                            md: "14px",
                          },
                          textTransform: "none",
                          pt: 1.5,
                          pb: 1.5,
                          boxShadow: "0px 4px 4px rgba(239, 239, 239, 1)",
                          background: data?.isGoal
                            ? process.env.REACT_APP_PRIMARY_COLOR
                            : metalType === "Sip"
                            ? process.env.REACT_APP_PRIMARY_COLOR
                            : "#FFF",
                          color: data?.isGoal
                            ? "#fff"
                            : metalType === "Sip"
                            ? "#fff"
                            : "#000",
                          width: data?.isGoal ? "100%" : "50%",
                          borderTopLeftRadius: data?.isGoal ? 10 : 0,
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                          borderTopRightRadius: 10,
                          "&:hover": {
                            background:
                              metalType === "Sip"
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FFF",
                          },
                        }}
                      >
                        {data?.isGoal ? "Create Goal" : "Start SIP"}
                      </Button>

                      {metalType === "Onetime" && (
                        <>
                          <Grid
                            sx={{ ml: 2, mt: 2 }}
                            justifyContent="flex-start"
                            alignSelf="flex-start"
                          >
                            <H5 fontWeight={400} color="#838181" fontSize={13}>
                              Minimum Investment Required: ₹{buyMinAmount}
                            </H5>
                          </Grid>

                          <Box sx={sxStyleBox3}>
                            <H5 sx={{ mt: 2 }} fontSize={16}>
                              Investment Amount
                            </H5>
                            <TextField
                              name="onetime"
                              sx={textInputStyles}
                              InputProps={{
                                style: {
                                  height: "35px", // change this value to set the desired height
                                  width: "100%",
                                },
                              }}
                              onChange={oneTimeChangeHandler}
                              value={investedAmount}
                            />
                          </Box>

                          <Grid justifyContent="center" sx={sxStyleGrid14}>
                            <Grid
                              justifyContent="space-between"
                              alignSelf="center"
                              alignItems="center"
                              sx={{
                                display: "flex",
                                width: {
                                  md: "60%",
                                  xs: "90%",
                                },
                              }}
                            >
                              {/* first Button */}
                              <Box
                                onClick={() => {
                                  setFirstTouchableOpacity(true);
                                  setSecondTouchableOpacity(false);
                                  setThirdTouchableOpacity(false);
                                  setFourthTouchableOpacity(false);
                                  setInvestedAmount(
                                    Number(buyMinAmount).toString()
                                  );
                                }}
                                sx={{
                                  background: firstTouchableOpacity
                                    ? process.env.REACT_APP_PRIMARY_COLOR
                                    : "#FEF7E3",
                                  borderRadius: 2,
                                  p: 1,
                                  pt: 0.4,
                                  cursor: "pointer",
                                }}
                              >
                                <Small
                                  fontWeight={"700"}
                                  sx={{
                                    color: firstTouchableOpacity
                                      ? "#fff"
                                      : "#000",
                                  }}
                                >
                                  ₹{`${Number(buyMinAmount)}`}
                                </Small>
                              </Box>
                              {/* Second Button */}
                              <Box
                                onClick={() => {
                                  setFirstTouchableOpacity(false);
                                  setSecondTouchableOpacity(true);
                                  setThirdTouchableOpacity(false);
                                  setFourthTouchableOpacity(false);
                                  setInvestedAmount(
                                    (
                                      Number(buyMinAmount) * Number(firstValue)
                                    ).toString()
                                  );
                                }}
                                sx={{
                                  background: secondTouchableOpacity
                                    ? process.env.REACT_APP_PRIMARY_COLOR
                                    : "#FEF7E3",
                                  borderRadius: 2,
                                  p: 1,
                                  pt: 0.4,
                                  cursor: "pointer",
                                }}
                              >
                                <Small
                                  fontWeight={"700"}
                                  sx={{
                                    color: secondTouchableOpacity
                                      ? "#fff"
                                      : "#000",
                                  }}
                                >
                                  ₹
                                  {`${
                                    Number(buyMinAmount) * Number(firstValue)
                                  }`}
                                </Small>
                              </Box>
                              {/* Third Button */}
                              <Box
                                onClick={() => {
                                  setFirstTouchableOpacity(false);
                                  setSecondTouchableOpacity(false);
                                  setThirdTouchableOpacity(true);
                                  setFourthTouchableOpacity(false);
                                  setInvestedAmount(
                                    (
                                      Number(buyMinAmount) * Number(secondValue)
                                    ).toString()
                                  );
                                }}
                                sx={{
                                  background: thirdTouchableOpacity
                                    ? process.env.REACT_APP_PRIMARY_COLOR
                                    : "#FEF7E3",
                                  borderRadius: 2,
                                  p: 1,
                                  pt: 0.4,
                                  cursor: "pointer",
                                }}
                              >
                                <Small
                                  fontWeight={"700"}
                                  sx={{
                                    color: thirdTouchableOpacity
                                      ? "#fff"
                                      : "#000",
                                  }}
                                >
                                  ₹
                                  {`${
                                    Number(buyMinAmount) * Number(secondValue)
                                  }`}
                                </Small>
                              </Box>
                              {/* Forth Button */}
                              <Box
                                onClick={() => {
                                  setFirstTouchableOpacity(false);
                                  setSecondTouchableOpacity(false);
                                  setThirdTouchableOpacity(false);
                                  setFourthTouchableOpacity(true);
                                  setInvestedAmount(
                                    (
                                      Number(buyMinAmount) * Number(thirdValue)
                                    ).toString()
                                  );
                                }}
                                sx={{
                                  background: fourthTouchableOpacity
                                    ? process.env.REACT_APP_PRIMARY_COLOR
                                    : "#FEF7E3",
                                  borderRadius: 2,
                                  p: 1,
                                  pt: 0.4,
                                  cursor: "pointer",
                                }}
                              >
                                <Small
                                  fontWeight={"700"}
                                  sx={{
                                    color: fourthTouchableOpacity
                                      ? "#fff"
                                      : "#000",
                                  }}
                                >
                                  ₹
                                  {`${
                                    Number(buyMinAmount) * Number(thirdValue)
                                  }`}
                                </Small>
                              </Box>
                            </Grid>
                          </Grid>

                          {/* Payment */}
                          <Divider />
                          <Grid
                            justifyContent="space-between"
                            sx={{
                              display: "flex",
                              flexDirection: {
                                md: "row",
                                xs: "column",
                                sm: "row",
                              },
                              mt: {
                                md: 0,
                                xs: 1,
                                sm: 0,
                              },
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <H5
                                fontSize={12}
                                fontWeight={"400"}
                                sx={{
                                  fontFamily: "'Poppins', sans-serif",
                                  color: "#000000",
                                  display: "flex",
                                  ml: 1,
                                }}
                              >
                                <Box
                                  component="img"
                                  sx={{
                                    height: {
                                      md: 18,
                                      xs: 18,
                                      sm: 18,
                                    },
                                    minwidth: {
                                      md: 18,
                                      xs: 18,
                                      sm: 18,
                                    },
                                    mr: 1,
                                  }}
                                  src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/payment.svg"
                                  alt="saas-dasboard-footer"
                                />
                                Payment Method
                              </H5>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <RadioGroup
                                row
                                value={paymentValue}
                                onChange={handleChangePaymentrValue}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                              >
                                <FormControlLabel
                                  value="upi"
                                  control={<Radio sx={sxStyleRadio} />}
                                  label={<H4 fontSize={12}>UPI</H4>}
                                />
                                <FormControlLabel
                                  value="netbanking"
                                  control={<Radio sx={sxStyleRadio} />}
                                  label={<H4 fontSize={12}>Net Banking</H4>}
                                />
                              </RadioGroup>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid textAlign="center">
                            <Button
                              onClick={() => onNextBuyClick()}
                              disableElevation
                              disableRipple
                              size="medium"
                              sx={{
                                background:
                                  process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                                color: "#fff",
                                width: {
                                  md: "50%",
                                  xs: "90%",
                                },
                                mb: 1,
                                mt: { xs: 3, sm: 6.5, md: 6.5 },
                                textTransform: "none",
                              }}
                            >
                              Invest
                            </Button>
                          </Grid>
                        </>
                      )}
                      {metalType === "Sip" && (
                        <>
                          <Grid
                            sx={{ ml: 2, mt: 2 }}
                            justifyContent="flex-start"
                            alignSelf="flex-start"
                          >
                            {data?.isGoal ? null : (
                              <H5
                                fontWeight={400}
                                color="#838181"
                                fontSize={13}
                              >
                                Minimum Investment Required: ₹{minSipAmount}
                              </H5>
                            )}
                          </Grid>

                          <Box sx={sxStyleBox3}>
                            <Box
                              justifyContent="flex-start"
                              alignSelf="flex-start"
                              sx={{
                                width: {
                                  xs: "100%",
                                  sm: "100%",
                                  md: "100%",
                                },
                              }}
                            >
                              {data?.isGoal ? (
                                <H5 sx={{ mt: 2 }} fontSize={16}>
                                  Monthly Installment Amount
                                </H5>
                              ) : (
                                <H5 sx={{ mt: 2 }} fontSize={16}>
                                  Enter SIP Amount
                                </H5>
                              )}

                              {data?.isGoal ? (
                                <TextField
                                  name="onetime"
                                  disabled
                                  sx={textInputStyles}
                                  InputProps={{
                                    style: {
                                      height: "35px", // change this value to set the desired height
                                      width: "100%",
                                    },
                                  }}
                                  onChange={sipChangeHandler}
                                  value={investedSipAmount}
                                />
                              ) : (
                                <TextField
                                  name="onetime"
                                  sx={textInputStyles}
                                  InputProps={{
                                    style: {
                                      height: "35px", // change this value to set the desired height
                                      width: "100%",
                                    },
                                  }}
                                  onChange={sipChangeHandler}
                                  value={investedSipAmount}
                                />
                              )}
                            </Box>
                          </Box>
                          {data?.isGoal ? null : (
                            <Grid justifyContent="center" sx={sxStyleGrid14}>
                              <Grid
                                justifyContent="space-between"
                                alignSelf="center"
                                alignItems="center"
                                sx={{ display: "flex", width: "90%" }}
                              >
                                {/* first Button */}
                                <Box
                                  onClick={() => {
                                    setFirstTouchableOpacity(true);
                                    setSecondTouchableOpacity(false);
                                    setThirdTouchableOpacity(false);
                                    setFourthTouchableOpacity(false);
                                    setInvestedSipAmount(
                                      Number(minSipAmount).toString()
                                    );
                                  }}
                                  sx={{
                                    background: firstTouchableOpacity
                                      ? process.env.REACT_APP_PRIMARY_COLOR
                                      : "#FEF7E3",
                                    borderRadius: 2,
                                    p: 1,
                                    pt: 0.4,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Small
                                    fontWeight={"700"}
                                    sx={{
                                      color: firstTouchableOpacity
                                        ? "#fff"
                                        : "#000",
                                    }}
                                  >
                                    ₹{`${Number(minSipAmount)}`}
                                  </Small>
                                </Box>
                                {/* Second Button */}
                                <Box
                                  onClick={() => {
                                    setFirstTouchableOpacity(false);
                                    setSecondTouchableOpacity(true);
                                    setThirdTouchableOpacity(false);
                                    setFourthTouchableOpacity(false);
                                    setInvestedSipAmount(
                                      (
                                        Number(minSipAmount) *
                                        Number(firstValue)
                                      ).toString()
                                    );
                                  }}
                                  sx={{
                                    background: secondTouchableOpacity
                                      ? process.env.REACT_APP_PRIMARY_COLOR
                                      : "#FEF7E3",
                                    borderRadius: 2,
                                    p: 1,
                                    pt: 0.4,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Small
                                    fontWeight={"700"}
                                    sx={{
                                      color: secondTouchableOpacity
                                        ? "#fff"
                                        : "#000",
                                    }}
                                  >
                                    ₹
                                    {`${
                                      Number(minSipAmount) * Number(firstValue)
                                    }`}
                                  </Small>
                                </Box>
                                {/* Third Button */}
                                <Box
                                  onClick={() => {
                                    setFirstTouchableOpacity(false);
                                    setSecondTouchableOpacity(false);
                                    setThirdTouchableOpacity(true);
                                    setFourthTouchableOpacity(false);
                                    setInvestedSipAmount(
                                      (
                                        Number(minSipAmount) *
                                        Number(secondValue)
                                      ).toString()
                                    );
                                  }}
                                  sx={{
                                    background: thirdTouchableOpacity
                                      ? process.env.REACT_APP_PRIMARY_COLOR
                                      : "#FEF7E3",
                                    borderRadius: 2,
                                    p: 1,
                                    pt: 0.4,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Small
                                    fontWeight={"700"}
                                    sx={{
                                      color: thirdTouchableOpacity
                                        ? "#fff"
                                        : "#000",
                                    }}
                                  >
                                    ₹
                                    {`${
                                      Number(minSipAmount) * Number(secondValue)
                                    }`}
                                  </Small>
                                </Box>
                                {/* Forth Button */}
                                <Box
                                  onClick={() => {
                                    setFirstTouchableOpacity(false);
                                    setSecondTouchableOpacity(false);
                                    setThirdTouchableOpacity(false);
                                    setFourthTouchableOpacity(true);
                                    setInvestedSipAmount(
                                      (
                                        Number(minSipAmount) *
                                        Number(thirdValue)
                                      ).toString()
                                    );
                                  }}
                                  sx={{
                                    background: fourthTouchableOpacity
                                      ? process.env.REACT_APP_PRIMARY_COLOR
                                      : "#FEF7E3",
                                    borderRadius: 2,
                                    p: 1,
                                    pt: 0.4,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Small
                                    fontWeight={"700"}
                                    sx={{
                                      color: fourthTouchableOpacity
                                        ? "#fff"
                                        : "#000",
                                    }}
                                  >
                                    ₹
                                    {`${
                                      Number(minSipAmount) * Number(thirdValue)
                                    }`}
                                  </Small>
                                </Box>
                              </Grid>
                            </Grid>
                          )}
                          {/* date */}
                          <Divider />
                          <Grid
                            justifyContent="space-between"
                            sx={{ p: 1, display: "flex" }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <H5
                                fontSize={12}
                                fontWeight={"400"}
                                sx={{
                                  fontFamily: "'Poppins', sans-serif",
                                  color: "#000000",
                                  display: "flex",
                                }}
                              >
                                <Box
                                  component="img"
                                  sx={{
                                    height: 15,
                                    minwidth: {
                                      md: 15,
                                      xs: 10,
                                      sm: 10,
                                    },
                                    mr: 1,
                                  }}
                                  src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/calender.svg"
                                  alt="saas-dasboard-footer"
                                />
                                SIP Date
                              </H5>
                            </Grid>
                            <Grid
                              onClick={() => handlesipOpenModal()}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <H5
                                fontSize={12}
                                fontWeight={"400"}
                                sx={{
                                  fontFamily: "'Poppins', sans-serif",
                                  color: "#000000",
                                  flexDirection: "row",
                                  marginRight: 1,
                                }}
                              >
                                {` ${
                                  selectedDate == ""
                                    ? "Select installment date"
                                    : `${dateOrdinal(
                                        selectedDate
                                      )} of every month`
                                } `}
                              </H5>
                              <Box
                                component="img"
                                src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/dropDown.svg"
                                sx={sxStyleDropDown}
                              />
                            </Grid>
                          </Grid>
                          <Divider />
                          {/* Payment */}
                          {/* <Grid
                            justifyContent="space-between"
                            sx={{ display: "flex" }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <H5
                                fontSize={12}
                                fontWeight={"400"}
                                sx={{
                                  fontFamily: "'Poppins', sans-serif",
                                  color: "#000000",
                                  display: "flex",
                                  ml: 1,
                                }}
                              >
                                <Box
                                  component="img"
                                  sx={{
                                    height: 18,
                                    minwidth: {
                                      md: 18,
                                      xs: 10,
                                      sm: 10,
                                    },
                                    mr: 1,
                                  }}
                                  src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/payment.svg"
                                  alt="saas-dasboard-footer"
                                />
                                Payment Method
                              </H5>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <RadioGroup
                                row
                                value={paymentValue}
                                onChange={handleChangePaymentrValue}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                              >
                                <FormControlLabel
                                  value="upi"
                                  control={<Radio sx={sxStyleRadio} />}
                                  label={<H4 fontSize={12}>UPI</H4>}
                                />
                                <FormControlLabel
                                  value="netbanking"
                                  control={<Radio sx={sxStyleRadio} />}
                                  label={<H4 fontSize={12}>Net Banking</H4>}
                                />
                              </RadioGroup>
                            </Grid>
                          </Grid>
                          <Divider /> */}

                          <Grid textAlign="center">
                            <Button
                              onClick={() => onNextSIPClick()}
                              disableElevation
                              disableRipple
                              size="medium"
                              sx={{
                                background:
                                  process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                                color: "#fff",
                                width: {
                                  md: "50%",
                                  xs: "90%",
                                },
                                mb: 1,
                                mt: { xs: 3, sm: 6.5, md: 6.5 },
                                textTransform: "none",
                              }}
                            >
                              Start SIP
                            </Button>
                          </Grid>
                        </>
                      )}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <OTPModel
              open={openModal}
              handleClose={handleCloseModal}
              handleSave={handleSave}
            />
            <SIPdateModel
              open={sipdateModel}
              handleClose={handlesipCloseModal}
              handleSave={handleSaveSipDateModel}
              sipList={sipDateList || []} // add a default empty array if sipDateList is undefined
            />
            {/* Fund Info */}
            <Box
              sx={{
                display: { md: "flex", sm: "flex", xs: "none" },
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  mt: {
                    xs: 2,
                    sm: 2,
                    md: 0,
                  },
                  width: "100%",
                  flexDirection: "row",
                  background: "#fff",
                  borderRadius: 1,
                  display: "flex",
                }}
              >
                <Grid
                  onClick={() => {
                    setFundType("Returns");
                  }}
                  sx={{
                    background:
                      fundType === "Returns"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#FFF",
                    color: fundType === "Returns" ? "#fff" : "#000",
                    cursor: "pointer",
                    borderRadius: 1,
                    p: 1.5,
                  }}
                >
                  Returns
                </Grid>
                <Grid
                  onClick={() => {
                    setFundType("FundInfo");
                  }}
                  sx={{
                    borderRadius: 1,
                    background:
                      fundType === "FundInfo"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#FFF",
                    color: fundType === "FundInfo" ? "#fff" : "#000",
                    cursor: "pointer",
                    p: 1.5,
                  }}
                >
                  Fund Information
                </Grid>
                <Grid
                  onClick={() => {
                    setFundType("FolioDetails");
                  }}
                  sx={{
                    borderRadius: 1,
                    background:
                      fundType === "FolioDetails"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#FFF",
                    color: fundType === "FolioDetails" ? "#fff" : "#000",
                    cursor: "pointer",
                    p: 1.5,
                  }}
                >
                  Portfolio details
                </Grid>
                <Grid
                  onClick={() => {
                    setFundType("AmcDetails");
                  }}
                  sx={{
                    borderRadius: 1,
                    background:
                      fundType === "AmcDetails"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#FFF",
                    color: fundType === "AmcDetails" ? "#fff" : "#000",
                    cursor: "pointer",
                    p: 1.5,
                  }}
                >
                  AMC details
                </Grid>
                <Grid
                  onClick={() => {
                    setFundType("FundHouse");
                  }}
                  sx={{
                    borderRadius: 1,
                    background:
                      fundType === "FundHouse"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#FFF",
                    color: fundType === "FundHouse" ? "#fff" : "#000",
                    cursor: "pointer",
                    p: 1.5,
                  }}
                >
                  Fund House & Investment Objective
                </Grid>
              </Box>
              {fundType === "Returns" && <ReturnInformation item={flexiData} />}
              {fundType === "FundInfo" && <FundInformation item={flexiData} />}
              {fundType === "FolioDetails" && (
                <PortfolioDetails item={fundHoldingData} />
              )}
              {fundType === "AmcDetails" && (
                <AmcInformation item={flexiData?.general_info} />
              )}
              {fundType === "FundHouse" && (
                <FundHouseInformation item={flexiData} />
              )}
            </Box>
            <Grid sx={{ display: { md: "none", sm: "none" } }}>
              {/* Returns */}
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                  marginTop: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Returns
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <ReturnInformation item={flexiData} />
                  </Box>
                </AccordionDetails>
              </Accordion>
              {/* FundInfo */}
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                  marginTop: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Fund Information
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <FundInformation item={flexiData} />
                  </Box>
                </AccordionDetails>
              </Accordion>
              {/* FolioDetails */}
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                  marginTop: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Portfolio details
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <PortfolioDetails item={fundHoldingData} />
                  </Box>
                </AccordionDetails>
              </Accordion>
              {/* AmcDetails */}
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                  marginTop: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    AMC details
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <AmcInformation item={flexiData?.general_info} />
                  </Box>
                </AccordionDetails>
              </Accordion>
              {/* FundHouse */}
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                  marginTop: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Fund House & Investment Objective
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <FundHouseInformation item={flexiData} />
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}

const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  mt: 0.13,
};
const sxStylebutton = {
  background: "#F6F6F6",
  pl: {
    md: 4,
    xs: 2,
    sm: 2,
  },
  pr: {
    md: 4,
    xs: 2,
    sm: 2,
  },
  pt: 0,
};
const sxStyleRadio = {
  color: "#FFF5D1",
  "&.Mui-checked": {
    color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
  },
};
const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 50,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
};
const sxStyleDropDown = {
  height: {
    xs: 6,
    sm: 6,
    md: 6,
  },
  minwidth: {
    xs: 6,
    sm: 6,
    md: 6,
  },
};

const sxStyleDotStyle = {
  background: "#D9D9D9",
  width: {
    xs: 8,
    sm: 8,
    md: 10,
  },
  height: {
    xs: 8,
    sm: 8,
    md: 10,
  },
  borderRadius: {
    xs: 40,
    sm: 40,
    md: 20,
  },
  mr: 1,
  mt: 0.5,
};
const sxStyleBox1 = {
  borderRadius: 4,
  ml: { xs: 1, sm: 1, md: 2 },
  mr: { xs: 1, sm: 1, md: 2 },
  mt: { xs: 1, sm: 1, md: 3 },
  boxShadow: "0px 4px 10px rgba(239, 239, 239, 1)",
};
const sxStyleBox2 = {
  width: "100%",
  borderRadius: 2,
  pb: 1,
  display: "flex",
  flexDirection: "row",
};
const sxStyleBox5 = {
  background:
    "linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
  p: 0.7,
  pl: 2,
  pr: 2,
  borderRadius: 2,
  flexDirection: "row",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  mt: 0.2,
  mb: 1,
};
const sxStyleGrid9 = {
  display: "flex",
  alignSelf: "center",
  textAlign: "center",
  justifyContent: "space-evenly",
  alignItems: "center",
  mb: 2,
  p: 2,
};
const sxStyleGrid14 = {
  mb: 2,
  width: "100%",
  display: "flex",
};
const sxStyleGrid11 = {
  display: "flex",
  alignSelf: "center",
  textAlign: "center",
  justifyContent: "space-evenly",
  alignItems: "center",
  mb: 2,
};
const sxStyleFormalControlLabel = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "900",
  fontSize: "10px",
};
const sxStyleBox4 = {
  flexDirection: "column",
  width: {
    xs: "100%",
    sm: "100%",
    md: "50%",
  },
  mt: {
    md: 0,
    sm: 1,
    xs: 1,
  },
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "94%",
  },
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.1,
};
const sxStyleBox3 = {
  paddingX: 2,
  paddingY: 0.5,
  pb: 2,
};
const sxStyleGrid8 = {
  width: "100%",
};
